import React from 'react';
import classNames from "classnames";
import styles from "./odds-tooltip.content.module.scss";
import {OptionPreMatchRate} from "../../option-rates/option-pre-match-rate.js";

export const OddsTooltipContentPreMatchRate = ({option, controller, betsImpressionParams}) => {
  const {terms: {WEB_KO_ODDS_HOVER}} = controller;

  const rateProps = {
    option,
    controller,
    betsImpressionParams
  }

  return option.isPreMatchRateValid ? <div className={classNames(styles.pre_match_rate)}>
    {
      `${WEB_KO_ODDS_HOVER}: `
    }
    <OptionPreMatchRate {...rateProps}/>
  </div> : null
};
